import LOGO from "../images/LobosRFM.png";

export const Team__XLobos = {
  name: "Lobos RFM",
  logoImage: LOGO,
  teamImage: null,
  teamLogoColor: "#660F0F",
  teamJerseyColor: "#1B534C",

  // Stats
  gamesWon: 1,
  gamesLost: 2,
  gamesTied: 0,
  gamesTiedWon: 0,

  ownGoalsInFavor: 0,
  // goalsScoredAgainst: 47 + 34 + 70,

  goalsScoredAgainst: 34 + 70,
  defaultGoals: 0,

  isChampion: false,
  isEliminated: false,

  players: [
    {
      // goalsScored: 30 + 48 + 59,
      goalsScored: 48 + 59,

    },
  ],
};
